export default {
  recentThreshold: 2,
  recentThresholdUnit: 'week',
  fullData: false,
  groups: {},
  locations: []
}
